<template>
    <EmployeeTrack75Liquidation></EmployeeTrack75Liquidation>
</template>
<script>
    import EmployeeTrack75Liquidation from '@/components/EmployeeTrackApproved75Liquidation.vue'
    export default {
        name: 'employee-track-approved-liquidation',
        components: {
            EmployeeTrack75Liquidation
        }
    }
</script>